<section>
  <mat-icon>remove_circle</mat-icon>
  <h1>Remove</h1>
  <h2 mat-dialog-title>Are you sure to make this remove {{ data.name }}?</h2>
  <mat-dialog-actions align="center">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="accent" (click)="submit()">Submit</button>
  </mat-dialog-actions>
</section>
